import { useDataChange } from 'Simple/Data.js'

export function useOnChange(props) {
  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    change(next => {
      next.location_id = value.location_id
      next.location__id = value.location__id
      next.category = next.location_id ? 'all' : null
      next.question_id = null
    })
  }
}
